import React from "react";
import { ListPageHeader } from "../../common/DataList";
import RecipientStockFilters from "./RecipientStockFilters";
import RecipientStockTable from "./RecipientStockTable";

const RecipientStockList = () => (
  <div className="container-fluid px-5 my-5 list-page">
    <ListPageHeader title="Allocataires du stock" />
    <RecipientStockFilters />
    <RecipientStockTable />
  </div>
);

export default RecipientStockList;
